import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_acc_5: FaireProductEntity = {
  token: "nyc-acc-5",
  type: "product",
  name: "Greenwich Village Tote Bag",
  brandName: "Village Textiles",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/0df6f03900eccfb61f09216b82f305c98fd7a5cbd623880a66ab7eae38371801.webp",
  priceDollars: 28,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/0df6f03900eccfb61f09216b82f305c98fd7a5cbd623880a66ab7eae38371801.webp",
  weight: 0.4,
  dimensions: {
    width: 12,
    height: 14,
    depth: 4,
  },
  description: "Handcrafted canvas tote bag",
  categoryTokens: ["cat_accessories"],
  tags: ["nyc-local", "premium", "handmade", "sustainable"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
